function getConfig (brand, country, environment) {
  // Weird way of making it work on broker sites
  const baseConf = ({
    development: require('./development.json'),
    test: require('./test.json'),
    production: require('./production.json')
  })[environment]

  return {
    brand,
    country,
    environment,
    gateway: {
      url: baseConf.gateway.url[brand][country]
    },
    defaultOptions: baseConf.defaultOptions
  }
}

module.exports = {
  getConfig
}
